import React from 'react';

import Image from '../../components/Image/Image';
import TireInformationModal from '../../components/Tires/TireInformationModal';
import Currency from '../../../helpers/currency';
import { speedIndexToSpeed } from '../../../helpers/tiresHelper';
import TireEnergyLabelLinks from '../Tires/TireEnergyLabelLinks';
import { InternalLink } from '../../components/form-elements/Link';

export default function CompleteWheelRow({ completeWheel }) {
    const page = `/komplettraeder/${completeWheel.id}`;

    return (
        <div>
            <div className="uk-grid uk-grid-small" data-uk-grid="">
                <div className="uk-width-1-4@m uk-width-1-1">
                    <InternalLink to={page} modifier="reset">
                        <div className="uk-flex uk-flex-center uk-position-relative">
                            <div>
                                <div className="uk-flex uk-flex-middle" style={{ height: 235 }}>
                                    {/*TODO: imagelink*/}
                                    {completeWheel.imagelink && (
                                        <Image
                                            style={{ maxHeight: 235 }}
                                            src={completeWheel.imagelink}
                                            alt={completeWheel.neutralKey}
                                            resizeHeight={235}
                                        />
                                    )}
                                </div>
                            </div>
                        </div>
                    </InternalLink>
                </div>
                <div className="uk-width-expand">
                    <InternalLink to={page} modifier="reset">
                        <h2>
                            {completeWheel.reifenHersteller} / {completeWheel.felgenHersteller}
                        </h2>
                        <div>{completeWheel.warengruppe}</div>
                        <div>{completeWheel.bezeichnung}</div>
                        <div>
                            Geschwindigkeitsindex: {completeWheel.speedindex} bis {speedIndexToSpeed[completeWheel.speedindex]} km/h
                        </div>
                    </InternalLink>
                    <div className="uk-margin-small ">
                        <TireInformationModal tire={completeWheel} />
                    </div>
                </div>
                <div className="uk-width-1-4@m uk-width-1-1 uk-text-center">
                    <InternalLink to={page} modifier="reset">
                        <div className="uk-margin-auto-top uk-text-center">
                            <h3 className="uk-margin-remove-top">
                                <Currency quantity={completeWheel.vk_preis} />
                                <span className="uk-text-light uk-text-small"> /Stück</span>
                            </h3>
                        </div>
                    </InternalLink>
                    <div data-uk-grid="" className="uk-grid-small uk-child-width-1-1">
                        <div>
                            <InternalLink to={page} fullWidth modifier="secondary">
                                ZUM PRODUKT
                            </InternalLink>
                        </div>
                        <TireEnergyLabelLinks tire={completeWheel} />
                    </div>
                </div>
            </div>
            <hr />
        </div>
    );
}
